import Marquee from "react-fast-marquee";

const items = ["SCREENS DOWN", "FEATHERS UP"];

export const BrandMarquee = ({ dark = false }) => {
  return (
    <div
      className={`relative overflow-hidden border-y py-5 ${
        dark ? "border-white/10 bg-[#212121]" : "border-black/10 bg-[#EE4026]"
      }`}
      data-testid="brand-marquee"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span
              className={`font-display px-8 text-3xl uppercase tracking-tight sm:text-5xl ${
                dark ? "text-white" : "text-white"
              }`}
            >
              {t}
            </span>
            <span className={`text-2xl ${dark ? "text-[#EE4026]" : "text-[#184786]"}`}>✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
